import {
  bookingStatusEnum,
  PaymentMethod,
  PaymentStatus,
  PaymentType,
} from '../enums/enums';

const accessTokenKey = 'ss-access-token';

const BRAND_NAME = 'SportsSeek';

const COLORS = {
  skyBlue: {
    primary: '#009FC0',
    secondary: '#DDFAFF',
    medium: '#7FB3BC',
    light: '#E1FAFF',
    extraLight: '#C4E2E8',
  },
  grey: {
    primary: '#4D4D4D',
    secondary: '#A4A4A4',
    medium: '#828282',
    secondaryLight: '#E0E0E0',
    lightMedium: '#E6E6E6',
    light: '#F8F8F8',
    extraLight: '#ECECEC',
    dark: '#5E5E5E',
  },
  red: {
    primary: '#CA1506',
  },
  white: {
    primary: '#FFFFFF',
    cardBackground: '#F9FEFF',
  },
  orange: {
    primary: '#DEA707',
  },
  brown: {
    primary: '#914100',
  },
  blue: {
    primary: '#002C46',
    secondary: '#674BE2',
    medium: '#1A5FFB',
  },
  black: {
    primary: '#000000',
    background: '#00000099',
  },
  green: {
    secondary: '#05A742',
  },
};

const TEXT_SIZES = {
  TINY: 8,
  XXS: 10,
  XS: 12,
  SM: 14,
  MD: 16,
  BASE: 18,
  LG: 20,
  XL: 22,
  XXL: 24,
  XXXL: 26,
  FOUR_XL: 28,
  FIVE_XL: 30,
  SIX_XL: 32,
  SEVEN_XL: 34,
  EIGHT_XL: 36,
  NINE_XL: 38,
  TEN_XL: 40,
  ELEVEN_XL: 42,
  TWELVE_XL: 44,
  THIRTEEN_XL: 46,
  FOURTEEN_XL: 48,
  FIFTEEN_XL: 50,
  SIXTEEN_XL: 52,
  SEVENTEEN_XL: 54,
  EIGHTEEN_XL: 56,
  NINETEEN_XL: 58,
  HUGE: 60,
} as const;

const FONT_WEIGHTS = {
  THIN: 100,
  EXTRALIGHT: 200,
  LIGHT: 300,
  REGULAR: 400,
  MEDIUM: 500,
  SEMIBOLD: 600,
  BOLD: 700,
  EXTRABOLD: 800,
  HEAVY: 800,
} as const;

// Exports
export { accessTokenKey, BRAND_NAME, COLORS, TEXT_SIZES, FONT_WEIGHTS };

export const bookingStatus = [
  { value: bookingStatusEnum.Reserved, label: 'Reserved' },
  { value: bookingStatusEnum.Pending, label: 'Pending' },
  { value: bookingStatusEnum.Confirmed, label: 'Confirmed' },
  { value: bookingStatusEnum.Cancelled, label: 'Cancelled' },
  { value: bookingStatusEnum.Completed, label: 'Completed' },
];

export const USER_ENTITY_STATUS_OPTIONS = [
  { label: 'Active', value: 1 },
  { label: 'Inactive', value: 0 },
  { label: 'Deleted', value: -1 },
];

export const DateFormatStrings = {
  DD_MMMM_YYYY_h_mm_A: 'DD MMMM YYYY, h:mm A',
  hh_mm_ss: 'HH:mm:ss',
  hh_mm_A: 'hh:mm A',
  YYYY_MM_DD: 'YYYY-MM-DD',
  h_mm_A: 'h:mm A',
  dddd_MMMM_D_YYYY: 'dddd MMMM D, YYYY',
  ddd_MMM_D: 'ddd MMM D',
  DD_MMM_YYYY: 'DD MMM YYYY',
  MM_DD_YYYY: 'MM-DD-YYYY',
  DD_MM_YYYY: 'DD/MM/YYYY',
};

export const TOURNAMENT_TYPE_COLORS: Record<string, string> = {
  Singles: COLORS.skyBlue.medium,
  Doubles: COLORS.green.secondary,
  MixedDoubles: COLORS.red.primary,
  Team: COLORS.orange.primary,
};

export const paymentTypeOptions = [
  { value: PaymentType.Booking, label: 'Booking' },
  { value: PaymentType.EventRegistration, label: 'Event Registration' },
];

export const paymentStatusOptions = [
  { value: PaymentStatus.Pending, label: 'Pending' },
  { value: PaymentStatus.Processing, label: 'Processing' },
  { value: PaymentStatus.Completed, label: 'Completed' },
  { value: PaymentStatus.Failed, label: 'Failed' },
  { value: PaymentStatus.Refunded, label: 'Refunded' },
  { value: PaymentStatus.Cancelled, label: 'Cancelled' },
  { value: PaymentStatus.PartiallyRefunded, label: 'Partially Refunded' },
];

export const paymentMethodOptions = [
  { value: PaymentMethod.CreditCard, label: 'Credit Card' },
  { value: PaymentMethod.DebitCard, label: 'Debit Card' },
  { value: PaymentMethod.UPI, label: 'UPI' },
  { value: PaymentMethod.NetBanking, label: 'Net Banking' },
  { value: PaymentMethod.Wallet, label: 'Wallet' },
  { value: PaymentMethod.Cash, label: 'Cash' },
];
